import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Flex,
  Text,
  Checkbox,
  Menu,
  MenuButton,
  Button,
  MenuItem,
  MenuList,
  Spinner,
  useToast,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { MdEdit, MdOutlineChevronRight, MdDelete } from "react-icons/md";
import React, { Fragment, useState } from "react";
import AllFillters from "./Layout/AllFillters";
import { Link } from "react-router-dom";
import { AiOutlineDown } from "react-icons/ai";
import axios from "axios";
import { Auth } from "./Auth";
import { useRef } from "react";
import { Context } from "./store";

function AllUserAccess({
  data,
  accessDrop,
  title,
  head,
  renderData,
  isLoading2,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  data.sort((a, b) => {
    return new Date(b.createdAt) - new Date(a.createdAt);
  });

  const menuButton = {
    px: "2",
    py: "2",
    bgColor: "rgba(67, 138, 254, 0.3)",
    _hover: { bgColor: "rgba(67, 138, 254, 0.1)" },
    color: "#438AFE",
    borderRadius: "3px",
  };

  console.log(accessDrop, data, "xxxxxxxxxxxxx");
  //   #### Remove Member Permission ####
  const emberPermission = (id, userId, isAvail) => {
    setIsLoading(true);
    if (isAvail) {
      let data = JSON.stringify({
        userGroupId: "MEMEBER",
        userPermissionId: `${id}`,
        userId: `${userId}`,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/remove-access`,
        headers: {
          "Content-Type": "application/json",
          Authorization: Auth(),
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          renderData();
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      let data = JSON.stringify({
        userGroupId: "MEMBER",
        userPermissions: [`${id}`],
        userId: `${userId}`,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/assign-access`,
        headers: {
          "Content-Type": "application/json",
          Authorization: Auth(),
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));
          setIsLoading(false);
          renderData();
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const { userData } = React.useContext(Context);
  const user = userData;
  const deactiveUserHandler = (id) => {
    //   let data = JSON.stringify({
    //     "userAccountId": `${id}`
    //   });

    //   let config = {
    //     method: 'post',
    //     maxBodyLength: Infinity,
    //     url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/remove-user-account`,
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Authorization': Auth(),
    //       data : data
    //   }
    // }

    //   axios.request(config)
    //   .then((response) => {
    //     console.log(JSON.stringify(response.data));
    //     toast({
    //       title: `${response.data.message}`,
    //       status: 'success',
    //       duration: 4000,
    //       position: 'top',
    //       isClosable: true,
    //     })
    //     renderData()
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     toast({
    //       title: `Oops we are facing some temporary issue with your request!`,
    //       status: 'error',
    //       duration: 4000,
    //       position: 'top',
    //       isClosable: true,
    //     })
    //   });
    let data = JSON.stringify({
      userAccountId: id,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/user-account/remove-user-account`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        toast({
          title: `${response.data.message}`,
          status: "success",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
        renderData();
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: `Oops we are facing some temporary issue with your request!`,
          status: "error",
          duration: 4000,
          position: "top",
          isClosable: true,
        });
      });
  };

  return (
    <Fragment>
      <AllFillters title={title} data={data} renderData={renderData} />
      <Box maxW={"full"} my={4}>
        <TableContainer>
          <Table variant={"simple"} size={"xs"}>
            <Thead bgColor={"gray.100"}>
              <Tr bgColor={"#E2DFDF"}>
                {head.map((h, i) => (
                  <Th
                    key={i}
                    fontSize={"xs"}
                    py={3}
                    _first={{ paddingLeft: "33px" }}
                    color={"#25282B"}
                  >
                    {h}
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {data.length > 0 ? (
                <>
                  {data.map((d, index) => (
                    <Tr key={index} bgColor={"white"} h={"50px"}>
                      <Td fontSize={"xs"} py={3} pl={4}>
                        <Text overflowWrap={"break-word"}>
                          {d.userName || d.firstName + " " + d.lastName}
                        </Text>
                      </Td>
                      <Td fontSize={"xs"} py={3}>
                        <Text as="span">{d.email || "n/a"}</Text>
                      </Td>
                      <Td fontSize={"xs"} py={3}>
                        <Text as="span">{d.phone || "n/a"}</Text>
                      </Td>
                      <Td fontSize={"xs"} py={3}>
                        {d.UserGroupPermission.length > 0 ||
                        d.UserGroupMember.length > 0 ? (
                          <Text
                            as="span"
                            px={3}
                            py={"6px"}
                            color={
                              d.role === "Delivery Boy" ? "black" : "white"
                            }
                            rounded={"full"}
                            fontWeight={"semibold"}
                            bgColor={
                              d?.UserGroupMember?.some(
                                (x) => x.userGroupId === "ADMIN"
                              )
                                ? "#8BC34A"
                                : d?.UserGroupMember?.some(
                                    (x) => x.userGroupId === "DELEVERY_BOY"
                                  )
                                ? "#F6D046"
                                : d?.UserGroupMember?.some(
                                    (x) => x.userGroupId === "MEMBER"
                                  )
                                ? "#F68546"
                                : "#blue"
                            }
                          >
                            {d?.UserGroupMember?.map((x, ind) => (
                              <Text as="span" key={ind}>
                                {x.userGroupId.split("_").join(" ")}
                                {d?.UserGroupMember.length > 0 &&
                                  d?.UserGroupMember.length - 1 !== ind &&
                                  " | "}
                              </Text>
                            ))}
                          </Text>
                        ) : (
                          <Box w={"25%"} h={"1.5px"} bgColor={"black"}></Box>
                        )}
                      </Td>
                      {/* Access */}
                      <Td fontSize={"xs"} py={3}>
                        {d?.UserGroupMember?.some(
                          (x) => x.userGroupId === "MEMBER"
                        ) ? (
                          <Menu closeOnSelect={false}>
                            <MenuButton
                              rightIcon={<AiOutlineDown fontSize={"14px"} />}
                              as={Button}
                              sx={menuButton}
                              h={"auto"}
                            >
                              <Text
                                fontSize={"13px"}
                                color={"#438AFE"}
                                mb={"1.2px"}
                                textAlign={"left"}
                              >
                                Order Management
                              </Text>
                            </MenuButton>
                            <MenuList>
                              {accessDrop.map((element, inx) => {
                                return (
                                  <MenuItem key={inx}>
                                    <Checkbox
                                      isDisabled={isLoading}
                                      colorScheme="green"
                                      isChecked={d.UserGroupPermission.some(
                                        (x) => x.userPermissionId === element.id
                                      )}
                                      onChange={() =>
                                        emberPermission(
                                          element.id,
                                          d.id,
                                          d.UserGroupPermission.some(
                                            (x) =>
                                              x.userPermissionId === element.id
                                          )
                                        )
                                      }
                                    >
                                      {element.title}
                                    </Checkbox>
                                  </MenuItem>
                                );
                              })}
                            </MenuList>
                          </Menu>
                        ) : (
                          <Box w={"25%"} h={"1.5px"} bgColor={"black"}></Box>
                        )}
                      </Td>
                      <Td fontSize={"xs"} py={3} textAlign={"center"}>
                        <Flex>
                          {/* <Box bgColor={'#8BC34A'} p={'4px'} rounded={'xl'} mr={2}>
                                            <MdEdit color={'white'}/>  
                                        </Box> */}

                          {d.UserGroupPermission.length > 0 ||
                          d.UserGroupMember.length > 0 ? (
                            user.email !== d.email &&
                            d.email !== "super@equipp.com" ? (
                              <Box
                                bgColor={"red.500"}
                                p={"4px"}
                                rounded={"xl"}
                                cursor={"pointer"}
                              >
                                {/* <MdDelete
                                color={"white"}
                                onClick={() => deactiveUserHandler(d.id)}
                              /> */}
                                <DialogueBox
                                  deactiveUserHandler={deactiveUserHandler}
                                  d={d}
                                />
                              </Box>
                            ) : user.email === d.email ? (
                              <Text color={"green.500"} fontWeight={"bold"}>
                                Logged In
                              </Text>
                            ) : user.email !== d.email && d.email === 'super@equipp.com' && <Box
                            w={"25%"}
                            h={"1.5px"}
                            bgColor={"black"}
                          ></Box>
                          ) : 
                          <Text color={"red.500"} fontWeight={"bold"}>
                            Deactive
                          </Text>}

                          
                        </Flex>
                      </Td>
                      {/* <Td fontSize={'xs'} textAlign={'center'}>
                        <Flex>
                          <Box bgColor={'gray.200'} rounded={'full'} my="auto" p={2} mx={2}>
                            <Link to={`/user-access/details/${d.id}`} > <MdOutlineChevronRight /> </Link>
                          </Box>
                        </Flex>
                      </Td> */}
                    </Tr>
                  ))}
                </>
              ) : (
                <>
                  <Tr>
                    <Td></Td>
                    <Td></Td>
                    <Td textAlign={"center"}>
                      {isLoading2.loading === true ? (
                        <Spinner
                          thickness="4px"
                          speed="0.65s"
                          emptyColor="gray.200"
                          color="blue.500"
                          size="xl"
                          mt={4}
                        />
                      ) : isLoading2.error === true ? (
                        <Text fontWeight={"semibold"} color={"red.500"}>
                          Oops we are facing some temporary issue with your
                          request
                        </Text>
                      ) : (
                        <Text fontWeight={"semibold"} color={"green.500"}>
                          NO USER AVAILABLE
                        </Text>
                      )}{" "}
                    </Td>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                    <Td></Td>
                  </Tr>
                </>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    </Fragment>
  );
}

export default AllUserAccess;

export const DialogueBox = ({ deactiveUserHandler, d }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  return (
    <div>
      <MdDelete color={"white"} onClick={onOpen} />

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Deactive Customer
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You want to deactive this user.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                No
              </Button>
              <Button
                colorScheme="red"
                onClick={() => deactiveUserHandler(d.id)}
                ml={3}
              >
                Yes
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </div>
  );
};
